import { configureStore } from '@reduxjs/toolkit';
import { createInjectorsEnhancer } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';

import { createReducer, IReducers } from './reducers';

export function configureAppStore(staticReducers: IReducers = {}, _middleware: any[] = []) {
    const createReducerHandler = createReducer(staticReducers);

    const reduxSagaMonitorOptions = {};
    const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
    const { run: runSaga } = sagaMiddleware;

    // Create the store with saga middleware
    const middleware = [sagaMiddleware, ..._middleware];

    const enhancers = [
        createInjectorsEnhancer({
            createReducer: createReducerHandler,
            runSaga,
        }),
    ];
    return configureStore({
        reducer: createReducerHandler(),
        // REF: https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
        //middleware: [/*...getDefaultMiddleware(),*/ ...middleware],
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['persist/PERSIST', 'createStyle/addFinalImageBlob'],
                    ignoredPaths: ['createStyle.finalImageBlob'],
                },
            }).concat(middleware),
        devTools: true,
        enhancers,
    });
}
